/**
 * Convert raw /n lines to HTML <br>
 * @param {string} s
 */

const nl2br = s => s.replace(/(?:\r\n|\r|\n)/g, `<br />`)

export default nl2br
